<template>
  <DefaultLayout>
    <template v-slot:header>
      <CoastHeader :hasBackButton="false" :title="$t('My submissions')"></CoastHeader>
    </template>

   <ion-toolbar>
     <ion-segment v-model="selectedTab" value="submissions" @ionChange="onTabChange" class="segment-tabs">
       <ion-segment-button  value="submissions">
         <ion-label>{{ $t('Submissions') }}</ion-label>
       </ion-segment-button>
       <ion-segment-button value="drafts">
         <ion-label>{{ $t('Drafts') }}</ion-label>
       </ion-segment-button>
     </ion-segment>
   </ion-toolbar>
  <ion-content>
    <ion-list v-if="selectedTab === 'submissions' && items">
      <SubmissionItem v-for="item in items" :key="item.id" :item="item"></SubmissionItem>
    </ion-list>
    <ion-list v-else-if="selectedTab === 'drafts' && drafts">
      <SubmissionItem v-for="draft in drafts" :key="draft.id" :item="draft" @refreshList="updateDrafts"></SubmissionItem>
    </ion-list>
  </ion-content>
  </DefaultLayout>
</template>

<script>
import CoastHeader from "@/components/CoastHeader.vue"
import SubmissionItem from "@/components/SubmissionItem.vue"
import DefaultLayout from "@/views/layouts/default.vue"
import ApiService from "@/services/api.service";
import {mapGetters} from "vuex";
import {IonToolbar, IonSegment, IonSegmentButton, IonLabel, IonContent, IonList} from "@ionic/vue";
import Storage from "@/utils/storage";

export default {
  name: "Submissions",
  components: { CoastHeader, SubmissionItem, DefaultLayout, IonToolbar, IonSegment, IonSegmentButton, IonLabel, IonContent, IonList},
  data() {
    return {
      items: null,
      drafts: null,
      selectedTab: 'submissions' // Default to submissions tab
    }
  },
  computed: {
    ...mapGetters("auth", ["user"])
  },
  async created () {
    ApiService.get(`client/user/${this.user.id}`)
      .then(data => {
        this.items = data.data.submission_entries
      })

    await this.updateDrafts();
  },
  methods: {
    onTabChange(event) {
      this.selectedTab = event.detail.value;
    },
    async updateDrafts() {
      const localDrafts =  JSON.parse((await Storage.get({ key: 'drafts' }))?.value || '[]');
      this.drafts = localDrafts.filter(draft => draft.userId === this.user.id);
    }
  }
}
</script>

